import React, { useState, Fragment } from 'react';
import { InventoryItem, RoomInventory } from '../types/Inventory';
import { ChevronLeftIcon, ChevronRightIcon, PlusIcon, MoreHorizontalIcon } from 'lucide-react';
import { AddInventoryModal } from '../components/inventory/AddInventoryModal';
export function Inventory() {
  // Date range state
  const [dateRange, setDateRange] = useState('10/01/2025 - 11/01/2025');
  // Modal state
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  // Mock inventory data based on the screenshot
  const [inventoryData, setInventoryData] = useState<InventoryItem[]>([{
    date: '2025-10-01',
    dayOfWeek: 'Wednesday',
    roomTypes: [{
      roomType: 'Premium Overwater Villa',
      roomCode: 'POWVDTAC',
      availableRooms: 50,
      cta: false,
      ctd: false,
      blo: false
    }, {
      roomType: 'Water Villa',
      roomCode: 'SUNSIYAMEX',
      availableRooms: 3,
      cta: false,
      ctd: false,
      blo: false
    }]
  }, {
    date: '2025-10-02',
    dayOfWeek: 'Thursday',
    roomTypes: [{
      roomType: 'Premium Overwater Villa',
      roomCode: 'POWVDTAC',
      availableRooms: 50,
      cta: false,
      ctd: false,
      blo: false
    }, {
      roomType: 'Water Villa',
      roomCode: 'SUNSIYAMEX',
      availableRooms: 3,
      cta: false,
      ctd: false,
      blo: false
    }]
  }, {
    date: '2025-10-03',
    dayOfWeek: 'Friday',
    roomTypes: [{
      roomType: 'Premium Overwater Villa',
      roomCode: 'POWVDTAC',
      availableRooms: 50,
      cta: false,
      ctd: false,
      blo: false
    }, {
      roomType: 'Water Villa',
      roomCode: 'SUNSIYAMEX',
      availableRooms: 3,
      cta: false,
      ctd: false,
      blo: false
    }]
  }, {
    date: '2025-10-04',
    dayOfWeek: 'Saturday',
    roomTypes: [{
      roomType: 'Premium Overwater Villa',
      roomCode: 'POWVDTAC',
      availableRooms: 50,
      cta: false,
      ctd: false,
      blo: false
    }, {
      roomType: 'Water Villa',
      roomCode: 'SUNSIYAMEX',
      availableRooms: 3,
      cta: false,
      ctd: false,
      blo: false
    }]
  }, {
    date: '2025-10-05',
    dayOfWeek: 'Sunday',
    roomTypes: [{
      roomType: 'Premium Overwater Villa',
      roomCode: 'POWVDTAC',
      availableRooms: 50,
      cta: false,
      ctd: false,
      blo: false
    }, {
      roomType: 'Water Villa',
      roomCode: 'SUNSIYAMEX',
      availableRooms: 3,
      cta: false,
      ctd: false,
      blo: false
    }]
  }]);
  // Room type filter
  const [roomTypeFilter, setRoomTypeFilter] = useState('all');
  // Format date for display
  function formatDate(dateString: string): string {
    const date = new Date(dateString);
    return `${date.getDate().toString().padStart(2, '0')} Oct ${date.getFullYear()}`;
  }
  // Handle adding new inventory
  const handleSaveInventory = (inventoryData: any) => {
    console.log('New inventory data:', inventoryData);
    // Here you would process the new inventory data and update the state
    // This is just a placeholder for the actual implementation
    // For demonstration, let's add a simple log message
    alert('Inventory added successfully!');
  };
  return <div className="space-y-6" data-id="element-8823">
      <div className="flex justify-between items-center" data-id="element-8824">
        <h1 className="text-2xl font-semibold text-gray-800" data-id="element-8825">Inventory</h1>
        <button onClick={() => setIsAddModalOpen(true)} className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md flex items-center" data-id="element-8826">
          <PlusIcon size={18} className="mr-1" data-id="element-8827" />
          Add Inventory
        </button>
      </div>
      {/* Date range and filters */}
      <div className="flex flex-wrap gap-3" data-id="element-8828">
        <div className="relative" data-id="element-8829">
          <input type="text" className="border border-gray-300 rounded-md px-3 py-2 w-48" value={dateRange} readOnly data-id="element-8830" />
          <div className="absolute inset-y-0 right-0 flex items-center pr-2" data-id="element-8831">
            <ChevronLeftIcon size={16} className="text-gray-400 cursor-pointer mr-1" data-id="element-8832" />
            <ChevronRightIcon size={16} className="text-gray-400 cursor-pointer" data-id="element-8833" />
          </div>
        </div>
        <select className="border border-gray-300 rounded-md px-3 py-2" value={roomTypeFilter} onChange={e => setRoomTypeFilter(e.target.value)} data-id="element-8834">
          <option value="all" data-id="element-8835">Select room type...</option>
          <option value="premium-overwater" data-id="element-8836">Premium Overwater Villa</option>
          <option value="water-villa" data-id="element-8837">Water Villa</option>
        </select>
      </div>
      {/* Inventory Table */}
      <div className="bg-white rounded-lg border border-gray-200 overflow-x-auto" data-id="element-8838">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-8839">
          <thead className="bg-gray-50" data-id="element-8840">
            <tr data-id="element-8841">
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-8842">
                Room Type
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-8843">
                Available Rooms
              </th>
              <th scope="col" className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-8844">
                CTA
              </th>
              <th scope="col" className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-8845">
                CTD
              </th>
              <th scope="col" className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-8846">
                BLO
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-8847">
                Actions
              </th>
            </tr>
          </thead>
          <tbody data-id="element-8848">
            {inventoryData.map((day, dayIndex) => <Fragment key={day.date} data-id="element-8849">
                {/* Date header */}
                <tr className="bg-gray-50" data-id="element-8850">
                  <td colSpan={6} className="px-6 py-3" data-id="element-8851">
                    <div className="font-medium text-gray-900" data-id="element-8852">
                      {formatDate(day.date)}
                    </div>
                    <div className="text-sm text-gray-500" data-id="element-8853">{day.dayOfWeek}</div>
                  </td>
                </tr>
                {/* Room inventory rows */}
                {day.roomTypes.map((room, roomIndex) => <tr key={`${day.date}-${room.roomCode}`} className="bg-white" data-id="element-8854">
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-8855">
                      <div className="text-sm font-medium text-gray-900" data-id="element-8856">
                        {room.roomType}
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-8857">
                        {room.roomCode}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-8858">
                      {room.availableRooms}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-center" data-id="element-8859">
                      <input type="checkbox" checked={room.cta} onChange={() => {
                  const newData = [...inventoryData];
                  newData[dayIndex].roomTypes[roomIndex].cta = !room.cta;
                  setInventoryData(newData);
                }} className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500" data-id="element-8860" />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-center" data-id="element-8861">
                      <input type="checkbox" checked={room.ctd} onChange={() => {
                  const newData = [...inventoryData];
                  newData[dayIndex].roomTypes[roomIndex].ctd = !room.ctd;
                  setInventoryData(newData);
                }} className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500" data-id="element-8862" />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-center" data-id="element-8863">
                      <input type="checkbox" checked={room.blo} onChange={() => {
                  const newData = [...inventoryData];
                  newData[dayIndex].roomTypes[roomIndex].blo = !room.blo;
                  setInventoryData(newData);
                }} className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500" data-id="element-8864" />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right" data-id="element-8865">
                      <button className="text-gray-400 hover:text-gray-500" data-id="element-8866">
                        <MoreHorizontalIcon size={18} data-id="element-8867" />
                      </button>
                    </td>
                  </tr>)}
              </Fragment>)}
          </tbody>
        </table>
      </div>
      {/* Add Inventory Modal */}
      <AddInventoryModal isOpen={isAddModalOpen} onClose={() => setIsAddModalOpen(false)} onSave={handleSaveInventory} data-id="element-8868" />
    </div>;
}